<template>
  <div class="player__cdn" v-if="PlayerReady">
    <video-player :autoplay="videoOptions?.autoplay" :options="videoOptions" :panorama="panorama"
      :rightClick="handleContextMenu" :leftClick="handleLeftClick" :showSettingsModal="handleShowSettingsModal"
      :showSubtitlesModal="handleShowSubtitlesModal" :showShareModal="handleShowShareModal"
      :showDownloadModal="handleShowDownloadModal" :isSubtitlesModalShown="showSubtitlesModal"
      :isAllModalsClosed="isAllModalsHidden" :setPlayer="setPlayer" :videoData="videoData" :cryptext="crypText"
      :isClassic="isClassic" :playlist="playlist" :loopOption="loopOption" :seekOption="seekOption" :loadSkin="loadSkin"
      @get-playlist="(e) => initData(e)" @closeModals="closeModals" :showModalchaptre="handleShowInfosModal" />

    <div id="rm-slides" v-if="slides && slides?.length" class="vjs-slide-items is-right slides-is-hiden">
               <div class="drag" id="drag">
        <div class="resizer" id="resizer" v-on:mousedown="utils.resizeSlide(mainPlayer.id())">
          <div class="icon_resizer" id="icon_resizer" v-on:mousedown="utils.resizeSlide(mainPlayer.id())">
          </div>
                  </div>
        <div id="show-hide-slides-button" class="show-hide-slides-button" style="display: none" v-on:click="utils.handleShowHideSlides">
          <span class="icon" v-html="SVG.RM_DOWN_ARROW_SVG"></span>
        </div>
      </div>
    
        <Slides :slides="slides" :player="mainPlayer" />



         </div>
 <div class="vjs-overlay-buttons " id="dark-overlay-buttons">
             <InteractiveButtons  v-if="slides && slides.length" :player="mainPlayer" />

      </div>
        <ThumbnailCarousel v-if="slides && slides?.length"  :slides="slides"  :player="mainPlayer" />
     

    <div id="components">
      <right-click-menu ref="rightClickMenu" v-if="showContextMenu" :contextMenuPos="contextMenuPos"
        :showStatsModal="handleShowStatsModal" :playerLoop="setPlayerLoop" :isRepeat="isRepeat" />
      <StatsModal v-if="showStatsModal" :closeStatsModal="handlCloseStatsModal" :player="mainPlayer"
        :videoData="videoData" />
      <SettingsModal v-if="showSettingsModal" :closeSettingsModal="handlCloseSettingsModal" :player="mainPlayer"
        :videoRef="player" :currentQualityIndex="currentQualityIndexUpdate" :currentRateIndex="currentRateIndexUpdate" :isLive="false"/>
      <SubtitlesModal v-if="showSubtitlesModal" :tracks="textTracks" :player="mainPlayer"
        :showSubtitlesModal="handleShowSubtitlesModal" />
      <ShareModal v-if="showShareModal && information?.share" :player="mainPlayer" :showShareModal="handleShowShareModal"
        :closeShareModal="handlCloseShareModal" :playerInfos="videoData" :pageURL="pageURL" />
      <DownloadModal v-if="showDownloadModal" :player="mainPlayer" :showDownloadModal="handleShowDownloadModal"
        :closeDownloadModal="handlCloseDownloadModal" :playerInfos="videoData" :cryptext="crypText" />
      <InteractiveModals :player="mainPlayer" />
      <InteractiveChapters :player="mainPlayer" />
      <Annotation :player="mainPlayer" />
      <CTA :player="mainPlayer" />
      <HiddenArea :player="mainPlayer" />
      <div class="vjs-bo-desc" v-if="isBo && infoOptions && videoOptions && !getSkinPreview">
        <p class="text">{{ videoOptions.videoId }} - {{ infoOptions.title }}</p>
      </div>
      <div v-if="infoOptions &&
        hasInformations &&
        ((!isBo|| getSkinPreview) || (isBo && isChapters)) &&
        PlayerReady &&
        !isClassic
        ">
        <button tabindex="0"  v-if="hasInfoAttributes" class="info-btn" @click="handleShowInfosModal"  v-html="SVG.INFO_SVG">
        </button>
        <InfosModal v-if="showInfoModal" :isBo="isBo" :isChapters="isChapters" :information="information" :poster="poster"
          :copyRight="copyRight" :player="mainPlayer" :mediaId="+getMediaId" :statsParams="statsParams"
          :mediaType="getMediaType" :closeInfosModal="handlCloseInfosModal">
        </InfosModal>

      </div>
    </div>

      </div>
  <div class="loader" v-else-if="!PlayerReady && !PlayerError"></div>

  <div class="error-text-container" v-else-if="PlayerErrorText === this.$t('player.forbiddenMedia')">
    <div style="
        display: flex;
        flex-direction: column;
        align-items: center;
        font-family: 'Roboto', sans-serif;
      ">
      <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23 0C10.2987 0 0 10.2987 0 23C0 35.7013 10.2987 46 23 46C35.7013 46 46 35.7013 46 23C46 10.2987 35.7013 0 23 0ZM23 42.0982C12.4549 42.0982 3.90179 33.5451 3.90179 23C3.90179 12.4549 12.4549 3.90179 23 3.90179C33.5451 3.90179 42.0982 12.4549 42.0982 23C42.0982 33.5451 33.5451 42.0982 23 42.0982Z"
          fill="white" />
        <path
          d="M20.5357 32.0357C20.5357 32.6893 20.7953 33.3161 21.2575 33.7782C21.7196 34.2404 22.3464 34.5 23 34.5C23.6536 34.5 24.2804 34.2404 24.7425 33.7782C25.2047 33.3161 25.4643 32.6893 25.4643 32.0357C25.4643 31.3821 25.2047 30.7553 24.7425 30.2932C24.2804 29.8311 23.6536 29.5714 23 29.5714C22.3464 29.5714 21.7196 29.8311 21.2575 30.2932C20.7953 30.7553 20.5357 31.3821 20.5357 32.0357ZM21.7679 26.2857H24.2321C24.458 26.2857 24.6429 26.1009 24.6429 25.875V11.9107C24.6429 11.6848 24.458 11.5 24.2321 11.5H21.7679C21.542 11.5 21.3571 11.6848 21.3571 11.9107V25.875C21.3571 26.1009 21.542 26.2857 21.7679 26.2857Z"
          fill="white" />
      </svg>
      <span style="margin-top: 20px; font-family: 'Roboto', sans-serif">{{
        this.$t('player.forbiddenMedia')
      }}</span>
    </div>
  </div>




  <div class="error-text-container" v-else-if="PlayerErrorText === 'YOU ARE NOT AUTHORIZED TO ACCESS THIS OFFLINE VIDEO'
      ">
    {{ $t("player.offlineVideo") }}.
  </div>
  <div class="error-text-container" v-else-if="PlayerErrorText === 'YOU ARE NOT AUTHORIZED TO ACCESS THIS VIDEO'
    ">
    <div style="
        display: flex;
        flex-direction: column;
        align-items: center;
        font-family: 'Roboto', sans-serif;
      ">
      <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23 0C10.2987 0 0 10.2987 0 23C0 35.7013 10.2987 46 23 46C35.7013 46 46 35.7013 46 23C46 10.2987 35.7013 0 23 0ZM23 42.0982C12.4549 42.0982 3.90179 33.5451 3.90179 23C3.90179 12.4549 12.4549 3.90179 23 3.90179C33.5451 3.90179 42.0982 12.4549 42.0982 23C42.0982 33.5451 33.5451 42.0982 23 42.0982Z"
          fill="white" />
        <path
          d="M20.5357 32.0357C20.5357 32.6893 20.7953 33.3161 21.2575 33.7782C21.7196 34.2404 22.3464 34.5 23 34.5C23.6536 34.5 24.2804 34.2404 24.7425 33.7782C25.2047 33.3161 25.4643 32.6893 25.4643 32.0357C25.4643 31.3821 25.2047 30.7553 24.7425 30.2932C24.2804 29.8311 23.6536 29.5714 23 29.5714C22.3464 29.5714 21.7196 29.8311 21.2575 30.2932C20.7953 30.7553 20.5357 31.3821 20.5357 32.0357ZM21.7679 26.2857H24.2321C24.458 26.2857 24.6429 26.1009 24.6429 25.875V11.9107C24.6429 11.6848 24.458 11.5 24.2321 11.5H21.7679C21.542 11.5 21.3571 11.6848 21.3571 11.9107V25.875C21.3571 26.1009 21.542 26.2857 21.7679 26.2857Z"
          fill="white" />
      </svg>
      <span style="margin-top: 20px; font-family: 'Roboto', sans-serif">{{
        $t("player.privatevd")
      }}</span>
    </div>
  </div>
  <div class="error-container" v-else>
    <img class="error-img" src="../assets/img/404.png" />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { noImage } from "../assets/img/constants/constants";
import InfosModal from "../components/parts/InfosModal/InfosModal.vue";
import RightClickMenu from "../components/parts/RightClickMenu/RightClickMenu.vue";
import StatsModal from "../components/parts/StatsModal/StatsModal.vue";
import SettingsModal from "../components/parts/SettingsModal/SettingsModal.vue";
import VideoPlayer from "../views/VideoPlayer.vue";
import SubtitlesModal from "../components/parts/SubtitlesModal/SubtitlesModal.vue";
import ShareModal from "../components/parts/ShareModal/ShareModal.vue";
import DownloadModal from "../components/parts/DownloadModal/DownloadModal.vue";
import InteractiveModals from "../components/richmedia/InteractiveModals/InteractiveModals.vue";
import InteractiveChapters from "../components/richmedia/InteractiveModals/InteractiveChapters.vue";
import Annotation from "../components/richmedia/Annotation/AnnotationItem.vue";
import CTA from "../components/richmedia/CTA/CtaItem.vue";
import HiddenArea from "../components/richmedia/HiddenArea/HiddenArea.vue";
import InteractiveButtons from "../components/richmedia/InteractiveButtons/InteractiveButtons.vue";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import Slides from "../components/richmedia/Slides/RmSlides.vue";
import axios from "axios";
import en from "../i18n/en_US";
import fr from "../i18n/fr_FR";
import store from "@/store";
import {SVG} from "../components/utils/const"
import ThumbnailCarousel from "../components/richmedia/Slides/ThumbnailCarousel";
import * as Utils from '../components/utils/richmedia';
import { durationToSeconds } from "../components/utils/helpers";



export default defineComponent({
  name: "emp-player",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  components: {
    VideoPlayer,
    RightClickMenu,
    StatsModal,
    SettingsModal,
    InfosModal,
    SubtitlesModal,
    ShareModal,
    DownloadModal,
    InteractiveModals,
    Annotation,
    CTA,
    HiddenArea,
    Slides,
    InteractiveButtons,
    InteractiveChapters,
    ThumbnailCarousel
  },
  props: [
    "standalone",
    "query",
    "url",
    "fileName",
    "autoplay",
    "loop",
    "controls",
    "src",
    "refPlayer",
  ],
  data() {
    return {
      utils:Utils,
            focusedPlayer: false,

      SVG:SVG,
      playlist: {},
      loaded: false,
      parsedStandalone: null,
    focusedSlides: false,
      parsedQuery: null,
      parsedUrl: "",
      videoFileName: "",
      player: {},
      mainPlayer: {},
      skinData:null,
      playerCSS: false,
      count: 0,
      options: {},
      playerHost: "",
      ApiHost: "",
      ApiToken: "",
      PlayerReady: false,
      PlayerError: false,
      PlayerErrorText: "",
      panorama: false,
      showContextMenu: false,
      showStatsModal: false,
      showSettingsModal: false,
      showShareModal: false,
      showDownloadModal: false,
      showInfoModal: false,
      showSubtitlesModal: false,
      textTracks: [],
      isRepeat: false,
      disableReapeat: false,
      currentQualityIndex: -1,
      currentRateIndex: 3,
      contextMenuPos: {
        xPos: 0,
        yPos: 0,
      },
      videoData: {
        playerOptions: {
          videoId: "",
          liveId: "",
          poster: "",
          muted: false,
        },
      },
      videoOptions: {
        autoplayPolicy: "",
        autoplay: false,
        controls: false,
        responsive: true,
        sources: [
          {
            src: "",
            type: "",
          },
        ],
        loop: false,
        vhs: { withCredentials: false },
        html5: {},
        flash: {},
        techOrder: [],
        rssURL: "",
        spriteUrl: "",
      },

      isBo: false,
      isChapters: false,
      slides: [],
      interactivityModals: [],
      interactivityAnnotations: [],
      interactivityHiddenArea: [],
      Chapters: [],
      interactivityCTA: {},
      information: {
        primary: {
          image: "",
        },
        share: {},
        exportOptions: {},
        files: [],
        sendMailOptions: {},
        chapters: [],
        client: "",
      },
      infoOptions: {},
      crypText: "",
      queryParams: {
        skin: "",
        plugin: "",
        lang: "",
      },
      isClassic: false,
      copyRight: "",
          };
  },
  mounted() {
      
      this.crypText = this.$route.params.ct.toString();
    this.queryParams = this.$route.query;
    this.isClassic = this.queryParams.skin === "classic";
    this.initData(this.crypText);


    window.addEventListener('message', (event) => {
        var receivedData = event.data;
                if (receivedData && receivedData.info === 'SkinMessage') {
                    this.skinData = receivedData.value;
                        this.loadSkin()
                        
        }else if (receivedData && receivedData.info === 'skin') {
         this.setSkinPreview(true)    
         }else if (receivedData && receivedData.info === 'navigateChapter'){
          const chapterInfos = receivedData.value;
          const timecode = durationToSeconds(chapterInfos?.time_code)
          if(chapterInfos && timecode){
            this.mainPlayer.currentTime(timecode)
          }

         }else if (receivedData && receivedData.info === 'navigateStartEnd'){
          this.setExtractVideoInfos(receivedData.value)
         }
    });
  },
  updated() {
    const mainVideoContainer = document.getElementById("vjs_video_3");
    const allComponents = document.getElementById("components");
    const video = document.querySelector(".vjs-tech");
    const poster = document.querySelector(".vjs-poster");
    const loadingSpinner = mainVideoContainer?.querySelector(".vjs-loading-spinner");
if (mainVideoContainer && loadingSpinner && allComponents) {
  mainVideoContainer.insertBefore(allComponents, loadingSpinner.nextSibling);
}else{
  mainVideoContainer?.appendChild(allComponents);

}
    mainVideoContainer?.addEventListener("click", (e) => {
      if ([video, mainVideoContainer, poster].includes(e.target)) {
        this.handlCloseSettingsModal();
        this.handlCloseShareModal();
        this.handlCloseDownloadModal();
        this.handlCloseInfosModal();
        this.handlCloseStatsModal();
        this.showSubtitlesModal = false;
      }
    });
  },
  methods: {
    ...mapActions(["updateVideoInfos","setSkinInfos" ,"setSkinPreview","setExtractVideoInfos"]),
     
    async initData(crypText) {
      const localCT = crypText ? crypText : this.crypText;
      let src = this.src;
      if (!src) {
        src = "prn44_jf19_1442";
      }
      if (src) {
        await axios
          .get(
            `https:${window.process?.env.URL_LIVE_INTRANET === window.location.hostname ? "//" + window.process?.env.URL_LIVE_INTRANET + "/player" : window.process?.env?.API_PLAYER}/api/video/player_param/${localCT}/infos`,
            {
              params: this.queryParams,
              headers: {
                authorization: `Bearer ${window.process?.env?.API_TOKEN}`,
              },
            }
          )
          .then((resp) => {
            const responseData = resp.data?.data;
            store.commit("setPlaylist", responseData?.playListOptions?.sources);
            responseData && responseData.playerOptions
              ? (responseData.playerOptions.poster +=
                `?v=` + new Date().getTime())
              : "";
            this.videoOptions = responseData?.playerOptions;
     

                              this.videoOptions.vhs = { withCredentials: false };
                                                 this.videoOptions.html5 = {
              vhs: {
                overrideNative: true,
              },
            };
            this.videoOptions.flash = {
              vhs: {
                overrideNative: false,
              },
            };
            this.videoOptions.responsive = true;
            this.videoOptions.spriteUrl =
              responseData?.playerOptions?.spriteUrl;
              
            this.videoData = responseData;
            let textTrackArray = responseData?.playerOptions?.textTracks;
            if (textTrackArray && textTrackArray.length) {
              textTrackArray.forEach((obj) => {
                if (obj.default) {
                  obj.selected = true;
                } else {
                  obj.selected = false;
                }

                const ccIcon = document.querySelector(".customSubsButton");
                if(ccIcon){
          if (obj.selected) {
                        ccIcon.innerHTML = SVG.CLOSED_CAPTIONS_ON;
                } else {
                        ccIcon.innerHTML = SVG.CLOSED_CAPTIONS_OFF;
                }
                }
   
              });

              this.textTracks = [
                {
                  default: true,
                  kind: "captions",
                  src: "",
                  srclang: "",
                  label: this.$t("modals.disableCaptions"),
                  selected: false,
                },
                ...textTrackArray,
              ];
            }
   
            this.isBo =
              responseData?.paramsOptions && responseData?.paramsOptions?.isBO;
            this.isChapters =
              responseData?.rmOptions &&
              (responseData?.rmOptions?.chapters
                ? responseData?.rmOptions?.chapters.length > 0
                : responseData?.rmOptions?.chapters);
            
            this.slides = responseData?.rmOptions?.slides?.filter(
              (slide) => slide.src
            );
            this.copyRight = responseData?.infoOptions?.copyright;
             this.infoOptions = responseData?.infoOptions;

            this.panorama = responseData?.panoramaOptions;
            this.videoOptions.autoplayPolicy = "no-user-gesture-required";
this.playlist = responseData?.playListOptions?.sources;
            this.loopOption = responseData?.playListOptions?.loop;
            this.seekOption = responseData?.playListOptions?.seek;
            this.information = {
              primary: responseData?.infoOptions || {},
              share: responseData?.shareOptions || {},
              exportOptions: responseData?.exportOptions || {},
              files: responseData?.files || [],
              sendMailOptions: responseData?.sendMailOptions,
              chapters: responseData?.rmOptions?.chapters || [],
              client: responseData?.client,
              isBo: responseData?.paramsOptions?.isBO
            };
           if(responseData.skinVideoOptions){
           this.skinData=responseData.skinVideoOptions
            }
            store.commit("sethasInfo", this.information);
        
            this.loadSkin()


            this.$nextTick(() => {
              this.updateVideoInfos(resp.data?.data);
              this.PlayerReady = true;
            });

            let elm = document.getElementsByClassName("vjs-big-play-button")[0];
            let playerDiv = document.getElementById("vjs_video_3");
            const windowWidth = window.innerWidth;
            if (elm) {
              if (windowWidth <= 480 && this.slides && this.slides.length) {
                document
                  .getElementsByTagName("video")[0]
                  ?.classList.add("video-slides");
                elm.style.cssText = "left:50%!important";
              }
              if (windowWidth >= 480 && this.slides && this.slides.length) {
                document
                  .getElementsByTagName("video")[0]
                  ?.classList.add("video-slides");
                elm.style.cssText = "left:25%!important";
              } else {
                document
                  .getElementsByTagName("video")[0]
                  ?.classList.remove("video-slides");
                elm.style.cssText = "left:50%!important";
                playerDiv?.classList.remove("vjs-slides");
              }
            }
          })
          .catch((e) => {
            if (e?.response?.data?.code === 403) {
              this.PlayerErrorText = this.$t("player.forbiddenMedia");
              this.PlayerError = true;
            } else {
              this.PlayerErrorText = e?.response?.data?.error;
              this.PlayerError = true;
            }
          });


      } else {
        this.playerHost = "/404";
        this.PlayerError = true;
      }
    },
    closeModals() {
      this.showSettingsModal = false;
      this.showSubtitlesModal = false;
      this.showInfoModal = false;
      this.showStatsModal = false;
      this.showContextMenu = false;
    },
 checkInfoAttributes(obj) {
  return Object.keys(obj).some(key =>
   ( key.startsWith("info_") &&
    key !== "info_stats" &&
    key !== "info_logo" &&
    key !== "info_shortcuts" &&
    key !== "info_empreinte" &&
    obj[key])||(key === "action_rate" && obj[key] )
  );
},
 checkControllButtons(obj) {
  return Object.keys(obj).some(key =>
   ( key.startsWith("control_") &&
    obj[key])||((key === "action_download_video" || key === "info_shortcuts" || key === "info_empreinte") && obj[key] )
  );
},

 

    play() {
      this.mainPlayer.play();
    },
    pause() {
      this.mainPlayer.pause();
    },
    currentQualityIndexUpdate(i) {
      if (i >= -1) {
        this.currentQualityIndex = i;
      } else {
        return this.currentQualityIndex;
      }
    },
    currentRateIndexUpdate(i) {
      if (i >= 0) {
        this.currentRateIndex = i;
      }
      return this.currentRateIndex;
    },
    setPlayer(p, mainPlayer) {
      this.player = p;
      this.mainPlayer = mainPlayer;
      this.isRepeat=mainPlayer?.options_?.loop;
    },
    handleShowSettingsModal() {
      if (!this.showSettingsModal) {
        this.handlCloseInfosModal();
        this.handlCloseStatsModal();
        this.handlCloseShareModal();
        this.handlCloseDownloadModal();
        this.showSubtitlesModal = false;
      }
      this.showSettingsModal = !this.showSettingsModal;
      this.handleLeftClick();
    },
    handleShowSubtitlesModal() {
      if (!this.showSubtitlesModal) {
        this.handlCloseInfosModal();
        this.handlCloseStatsModal();
        this.handlCloseSettingsModal();
        this.handlCloseShareModal();
        this.handlCloseDownloadModal();
      }

      this.showSubtitlesModal = !this.showSubtitlesModal;
    },
    handleShowShareModal() {
      if (!this.showShareModal) {
        this.handlCloseInfosModal();
        this.handlCloseStatsModal();
        this.handlCloseSettingsModal();
      }
      this.showShareModal = !this.showShareModal;
    },
    handleShowDownloadModal() {
      if (!this.showDownloadModal) {
        this.handlCloseInfosModal();
        this.handlCloseStatsModal();
        this.handlCloseSettingsModal();
        this.handlCloseShareModal();
      }
      this.showDownloadModal = !this.showDownloadModal;
    },
    handlCloseSettingsModal() {
      this.showSettingsModal = false;
    },
    handlCloseShareModal() {
      this.showShareModal = false;
    },
    handlCloseDownloadModal() {
      this.showDownloadModal = false;
    },
    handleShowInfosModal() {
           if (!this.showInfoModal) {
        this.handlCloseStatsModal();
        this.handlCloseSettingsModal();
        this.handlCloseShareModal();
        this.handlCloseDownloadModal();
        this.showSubtitlesModal = false;
      }

      this.showInfoModal = !this.showInfoModal;
      this.handleLeftClick();
    },
    handlCloseInfosModal() {
      this.showInfoModal = false;
    },
    handleShowStatsModal() {
      if (!this.showStatsModal) {
        this.handlCloseInfosModal();
        this.handlCloseSettingsModal();
        this.handlCloseShareModal();
        this.handlCloseDownloadModal();
        this.showSubtitlesModal = false;
      }

      this.showStatsModal = !this.showStatsModal;
      this.handleLeftClick();
    },
    handlCloseStatsModal() {
      this.showStatsModal = false;
    },
    handleLeftClick() {
            if (this.showContextMenu) this.showContextMenu = false;
    },
    handleContextMenu(e) {
      e.preventDefault();
      this.showContextMenu = true;
      this.contextMenuPos.xPos = e.clientX;
      this.contextMenuPos.yPos = e.clientY;
    },
    setPlayerLoop() {
    if (this.getSkinInfos.action_loop) {
      this.isRepeat = !this.isRepeat;
      this.mainPlayer.loop(this.isRepeat);
      this.handleLeftClick();
    }
  },
loadSkin() {
        if (this.skinData !== null) {
        this.setSkinInfos(this.skinData);
     this.skinControl()
     
  }
},
skinControl(){
  if(!this.isClassic ){

    // Volume button
    const volumePanel = document.querySelector(".vjs-volume-panel.vjs-control");
    const volumeControl = document.querySelector(".vjs-volume-control.vjs-control");
    if (volumeControl && volumePanel) {
      if (!this.getSkinInfos.control_volume) {
        volumePanel.classList.add("vjs-hidden");
        volumeControl.classList.add("vjs-hidden");
      } else {
        volumePanel.classList.remove("vjs-hidden");
        volumeControl.classList.remove("vjs-hidden");
      }
    }
    
    // Ad Button
    const adButton = document.querySelector(".adSourceButton");

    if (adButton) {
      if (!this.getSkinInfos.control_audio_description) {
        adButton.classList.add("vjs-hidden");
      } else {
        adButton.classList.remove("vjs-hidden");
      }
    }

    // Chapter button
    const chapterButton = document.querySelector(".customMenuButton");

    if (chapterButton) {
      if (!this.getSkinInfos?.control_chapters) {
        chapterButton.classList.add("vjs-hidden");
      } else {
        chapterButton.classList.remove("vjs-hidden");
      }
    }

    // Fullscreen button
    const fullscreenButton = document.querySelector(".vjs-fullscreen-control");

    if (fullscreenButton) {
      if (!this.getSkinInfos?.control_fullscreen) {
        fullscreenButton.classList.add("vjs-hidden");
      } else {
        fullscreenButton.classList.remove("vjs-hidden");
      }
    }

    // Picture-in-picture button
    const pipButton = document.querySelector(".vjs-picture-in-picture-control.vjs-control.vjs-button");

    if (pipButton) {
      if (!this.getSkinInfos?.control_pip) {
            pipButton.style.display = "none";
      } else {

            pipButton.style.display = "block";
      }
    }

    // Progress bar
    const progressBar = document.querySelector(".vjs-progress-holder");

    if (progressBar) {
      if ( !this.getSkinInfos?.control_progress_bar) {
        progressBar.classList.add("vjs-hidden");
      } else {
        progressBar.classList.remove("vjs-hidden");
      }
    }

//start stopBtn
const stopBtn = document.querySelector(".vjs-stop-btn");

    if (stopBtn) {
      if (!this.getSkinInfos?.control_stop_btn) {
        stopBtn.classList.add("vjs-hidden");
      } else {
        stopBtn.classList.remove("vjs-hidden");
      }
    }
//start time 
const currentTime =  document.querySelector(".vjs-current-time-display");
const DurationDisplay =  document.querySelector(".vjs-duration-display");
const timeDivider = document.querySelector(".vjs-time-control.vjs-time-divider");
    if (currentTime &&DurationDisplay && timeDivider  ) {
      if (!this.getSkinInfos?.control_time) {
        currentTime.classList.add("vjs-hidden");
        DurationDisplay.classList.add("vjs-hidden");
        timeDivider.classList.add("vjs-hidden");
      } else {
               currentTime.classList.remove("vjs-hidden");
        DurationDisplay.classList.remove("vjs-hidden");
        timeDivider.classList.remove("vjs-hidden");
      }
    }
    // extract video
const ExtractButton =  document.querySelector(".customExtractButton");

if (ExtractButton  ) {
  if (!this.getSkinInfos?.control_extract  ) {
    ExtractButton.classList.add("vjs-hidden");

  } else {
    ExtractButton.classList.remove("vjs-hidden");

  }
}

// transcript
const TranscriptButton =  document.querySelector(".customDownlaodSubsButton");

    if (TranscriptButton  ) {
      if (!this.getSkinInfos?.control_transcript  ) {
        TranscriptButton.classList.add("vjs-hidden");

      } else {
               TranscriptButton.classList.remove("vjs-hidden");

      }
    }
//control bar visible
     const controlBAr =  document.querySelector(".vjs-control-bar");
if(controlBAr){
      if (!this.AllControllBarButtons ) {
        controlBAr.classList.add("vjs-hidden");   
      }else{
       controlBAr.classList.remove("vjs-hidden");
      }



}


//download
 const downloadButton =  document.querySelector(".customDownloadButton");

    if (downloadButton  ) {
      if (!this.getSkinInfos?.action_download_video ) {
        downloadButton.classList.add("vjs-hidden");

      } else {
               downloadButton.classList.remove("vjs-hidden");

      }
    }
 const Sharebtn =  document.querySelector(".customShareButton");

    if (Sharebtn  ) {
      if (!this.getSkinInfos?.control_share  ) {
        Sharebtn.classList.add("vjs-hidden");

      } else {
               Sharebtn.classList.remove("vjs-hidden");

      }
    }
//audiotrack
const audioButton = document.querySelector(".vjs-audio-button.vjs-menu-button.vjs-menu-button-popup.vjs-control.vjs-button");

if (audioButton) {
  if (!this.getSkinInfos?.control_audio_tracks) {
    audioButton.hidden=true;
  } else {
    audioButton.hidden=false;
  }
}

 const subtitlesButton =  document.querySelector(".customSubsButton");


 if (subtitlesButton  ) {
      if (!this.getSkinInfos?.control_subtitles) {
        subtitlesButton.classList.add("vjs-hidden");

      } else {
               subtitlesButton.classList.remove("vjs-hidden");

      }
    }
     const settingButton =  document.querySelector(".customSettingsButton");
if(settingButton){
      if (!this.getSkinInfos?.control_speed && !this.getSkinInfos?.control_quality && !this.getSkinInfos?.info_shortcuts && !this.getSkinInfos?.info_empreinte  ) {
        settingButton.classList.add("vjs-hidden")
        settingButton.classList.remove("vjs-settings-btn")
       
      }else{
        settingButton.classList.add("vjs-settings-btn")
        settingButton.classList.remove("vjs-hidden")
      }



}

 const Playbutton =  document.querySelector(".vjs-play-control");
const PlayBigButton=document.querySelector(".vjs-big-pause-button .vjs-icon-placeholder");
const PauseBigButton=document.querySelector(".vjs-big-play-button .vjs-icon-placeholder");

 if (Playbutton  ) {
      if (!this.getSkinInfos?.control_play_pause_btn  ) {
        Playbutton.classList.add("vjs-hidden");

      } else {
               Playbutton.classList.remove("vjs-hidden");

      }
    }
     if (PlayBigButton && PauseBigButton  ) {
      if (!this.getSkinInfos?.control_play_pause_btn  ) {
        PlayBigButton.classList.add("vjs-hidden");
        PauseBigButton.classList.add("vjs-hidden");

      } else {
               Playbutton.classList.remove("vjs-hidden");
                       PauseBigButton.classList.remove("vjs-hidden");


      }
    }

    
  }

}
    
  },
  computed: {
       ...mapGetters(["getSkinInfos" ,"getSkinPreview"]),
    playlistdata() {
      return store.getters.getPlaylist;
    },

  hasInfoAttributes() {
      return this.checkInfoAttributes(this.getSkinInfos);
    },
      AllControllBarButtons() {
      return this.checkControllButtons(this.getSkinInfos);
    },



    getMediaId() {
      if (this.videoData.playerOptions.videoId) {
        return this.videoData.playerOptions.videoId;
      } else {
        return this.videoData.playerOptions.liveId;
      }
    },
    getMediaType() {
      if (this.videoData.playerOptions.videoId) {
        return "vod";
      } else {
        return "live";
      }
    },
    pageURL() {
      return window.location.href;
    },
    poster() {
      const image = this.videoData.playerOptions
        ? this.videoData.playerOptions.poster
        : "";
      return image !== "" && image !== null
        ? this.videoData.playerOptions.poster
        : noImage;
    },
    hasInformations() {
      return (
        this.information &&
        Object.keys(this.information).length > 0 &&
        (Object.keys(this.information.primary).length > 0 ||
          Object.keys(this.information.share).length > 0 ||
          Object.keys(this.information.exportOptions).length > 0 ||
          this.information.files.length > 0 ||
          this.information.chapters.length > 0)
      );
    },

    isDarkSkin() {
      return this.information && Object.keys(this.information).length > 0;
    },
    statsParams() {
      return { videoId: this.getMediaId, client: this.information.client };
    },
    isAllModalsHidden() {
      return (
        this.showContextMenu ||
        this.showStatsModal ||
        this.showSettingsModal ||
        this.showSubtitlesModal ||
        this.showInfoModal
      );
    },

  },
});
</script>
